import { useQuery, type UseQueryOptions } from '@tanstack/react-query'
import type { MeDTO } from '@routr/shared'
import { apiFetch } from './client-api'

export const LAST_WORKSPACE_KEY = 'routr_ws'

export function rememberWorkspace(slug: string) {
  try {
    window.localStorage.setItem(LAST_WORKSPACE_KEY, slug)
  } catch {
    /* private mode */
  }
}
export function rememberedWorkspace(): string | null {
  try {
    return window.localStorage.getItem(LAST_WORKSPACE_KEY)
  } catch {
    return null
  }
}

/** One query per API path. */
export function useApi<T>(path: string | null, options: Partial<UseQueryOptions<T>> = {}) {
  return useQuery<T>({
    queryKey: ['api', path],
    queryFn: () => apiFetch<T>(path!),
    enabled: path !== null,
    staleTime: 10_000,
    retry: (count, error) => {
      const status = (error as { status?: number }).status
      return status === undefined || status >= 500 ? count < 2 : false
    },
    ...options,
  })
}

/** The signed-in person, or null when there is no session. */
export function useMe() {
  return useQuery<MeDTO | null>({
    queryKey: ['api', '/api/me'],
    queryFn: async () => {
      try {
        return await apiFetch<MeDTO>('/api/me')
      } catch (error) {
        if ((error as { status?: number }).status === 401) return null
        throw error
      }
    },
    staleTime: 30_000,
    retry: false,
  })
}
